import { defineComponent as _defineComponent } from 'vue'
export interface Props {
  item: Scene;
}


import { computed } from 'vue';

import type { Scene } from '@models';

const TEXT_COLOR_GREEN = '#004546';
const BG_COLOR_GREEN = '#37da88';

const TEXT_COLOR_RED = '#5d0029';
const BG_COLOR_RED = '#ff4f80';

declare module '@vue/runtime-core' {
  export interface GlobalComponents {
    TableCellPrivateStatus: ComponentWithProps<Props>;
  }
}

interface StatusDisplayConfig {
  text: string;
  color: string;
  backgroundColor: string;
}

/** Display config info for certification status label. */
const STATUS_DISPLAY_CONFIGS = {
  PRIVATE: {
    text: 'Private',
    color: TEXT_COLOR_RED,
    backgroundColor: BG_COLOR_RED,
  },
  NOT_PRIVATE: {
    text: 'Public',
    color: TEXT_COLOR_GREEN,
    backgroundColor: BG_COLOR_GREEN,
  },
} satisfies Record<string, StatusDisplayConfig>;

export default /*#__PURE__*/_defineComponent({
  __name: 'TableCellPrivateStatus',
  props: {
    item: null
  },
  setup(__props: any) {

const props = __props as {
  item: Scene;
};

/**
 * `TableCellPrivateStatus` component properties.
 */


const displayConfig = computed(() => {
  return props.item.isPrivate
    ? STATUS_DISPLAY_CONFIGS.PRIVATE
    : STATUS_DISPLAY_CONFIGS.NOT_PRIVATE;
});

const text = computed(() => {
  return displayConfig.value.text;
});

const style = computed(() => {
  return {
    color: displayConfig.value.color,
    backgroundColor: displayConfig.value.backgroundColor,
  };
});

return { __sfc: true,TEXT_COLOR_GREEN, BG_COLOR_GREEN, TEXT_COLOR_RED, BG_COLOR_RED, STATUS_DISPLAY_CONFIGS, props, displayConfig, text, style }
}

})